import { gql } from '@apollo/client';

export interface ListTaskDatesWithPendingAssignResponse {
  listTaskDatesWithPendingAssign: string[];
}

export interface ListTaskDatesWithPendingAssignVariables {
  request: {
    warehouseId: number;
    dspId?: number | null;
  };
}

export const LIST_TASK_DATES_WITH_PENDING_ASSIGN = gql`
  query ListTaskDatesWithPendingAssign($request: ListTaskDatesWithPendingAssignRequestInput!) {
    listTaskDatesWithPendingAssign(request: $request)
  }
`;
